import { createFileRoute } from "@tanstack/react-router";
import { VaccinesPage } from "@/modules/vaccines/presentation/pages/VaccinesPage";

export const Route = createFileRoute("/_authenticated/vaccines")({
  component: VaccinesPage,
});
